
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired651"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired651"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7xovm", function(module, exports) {

$parcel$export(module.exports, "getCurrentLanguage", () => $57ce9f9ca6d03c71$export$604ba5624273df44);
$parcel$export(module.exports, "getAvailableLanguages", () => $57ce9f9ca6d03c71$export$b16cb594c618e247);
$parcel$export(module.exports, "setLanguage", () => $57ce9f9ca6d03c71$export$4b6bf64406ec64af);
$parcel$export(module.exports, "t", () => $57ce9f9ca6d03c71$export$625550452a3fa3ec);
$parcel$export(module.exports, "translateI18n", () => $57ce9f9ca6d03c71$export$edfcd928cc828b32);
$parcel$export(module.exports, "initI18n", () => $57ce9f9ca6d03c71$export$8464cdd050ea8737);

var $6C6hx = parcelRequire("6C6hx");

var $8UcEY = parcelRequire("8UcEY");
/**
 * i18n utility for translations
 * Uses Proxy-based state management
 */ const $57ce9f9ca6d03c71$var$DEFAULT_LANG = 'es';
// Local references (will be set during init)
let $57ce9f9ca6d03c71$var$proxyState = null;
let $57ce9f9ca6d03c71$var$availableLanguages = [
    'es',
    'en'
];
function $57ce9f9ca6d03c71$export$604ba5624273df44() {
    if ($57ce9f9ca6d03c71$var$proxyState) return $57ce9f9ca6d03c71$var$proxyState.lang || $57ce9f9ca6d03c71$var$DEFAULT_LANG;
    return $57ce9f9ca6d03c71$var$DEFAULT_LANG;
}
function $57ce9f9ca6d03c71$export$b16cb594c618e247() {
    return $57ce9f9ca6d03c71$var$availableLanguages;
}
function $57ce9f9ca6d03c71$export$4b6bf64406ec64af(lang) {
    if (!(0, $6C6hx.translations)[lang]) {
        console.warn(`[i18n] Language ${lang} not available, falling back to ${$57ce9f9ca6d03c71$var$DEFAULT_LANG}`);
        lang = $57ce9f9ca6d03c71$var$DEFAULT_LANG;
    }
    if ($57ce9f9ca6d03c71$var$proxyState) $57ce9f9ca6d03c71$var$proxyState.lang = lang;
}
function $57ce9f9ca6d03c71$export$625550452a3fa3ec(key, fallback = null) {
    const lang = $57ce9f9ca6d03c71$export$604ba5624273df44();
    const keys = key.split('.');
    let value = (0, $6C6hx.translations)[lang];
    for (const k of keys)if (value && typeof value === 'object' && k in value) value = value[k];
    else {
        // Try fallback language
        value = (0, $6C6hx.translations)[$57ce9f9ca6d03c71$var$DEFAULT_LANG];
        for (const fk of keys)if (value && typeof value === 'object' && fk in value) value = value[fk];
        else {
            value = fallback?.[key] || key;
            break;
        }
        break;
    }
    return typeof value === 'string' ? value : fallback?.[key] || key;
}
function $57ce9f9ca6d03c71$export$edfcd928cc828b32(i18nObj, prop = 'name', fallback = '') {
    if (!i18nObj) return fallback;
    // If it's a string directly, return it
    if (typeof i18nObj === 'string') return i18nObj;
    const lang = $57ce9f9ca6d03c71$export$604ba5624273df44();
    // Get the language object
    let langObj = i18nObj[lang] || i18nObj[$57ce9f9ca6d03c71$var$DEFAULT_LANG];
    if (!langObj) {
        // Try any available language
        const firstKey = Object.keys(i18nObj)[0];
        langObj = firstKey ? i18nObj[firstKey] : null;
    }
    if (!langObj) return fallback;
    // If we need a specific property and it's an object
    if (prop && typeof langObj === 'object') return langObj[prop] || fallback;
    // Return as-is if it's already a string
    return typeof langObj === 'string' ? langObj : fallback;
}
function $57ce9f9ca6d03c71$export$8464cdd050ea8737(branchConfig, stateProxy) {
    $57ce9f9ca6d03c71$var$proxyState = stateProxy;
    // Set available languages from backend
    if (branchConfig?.availableLanguages) $57ce9f9ca6d03c71$var$availableLanguages = branchConfig.availableLanguages;
    // Priority 1: Check URL param (highest priority for sharing links)
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && $57ce9f9ca6d03c71$var$availableLanguages.includes(urlLang)) {
        $57ce9f9ca6d03c71$var$proxyState.lang = urlLang;
        return;
    }
    // Priority 2: Check cookie
    const cookieLang = (0, $8UcEY.getCookie)('lang');
    if (cookieLang && $57ce9f9ca6d03c71$var$availableLanguages.includes(cookieLang)) {
        $57ce9f9ca6d03c71$var$proxyState.lang = cookieLang;
        return;
    }
    // Priority 3: Backend default
    if (branchConfig?.defaultLanguage && $57ce9f9ca6d03c71$var$availableLanguages.includes(branchConfig.defaultLanguage)) {
        $57ce9f9ca6d03c71$var$proxyState.lang = branchConfig.defaultLanguage;
        return;
    }
    // Priority 4: Hardcoded default
    $57ce9f9ca6d03c71$var$proxyState.lang = $57ce9f9ca6d03c71$var$DEFAULT_LANG;
}
function $57ce9f9ca6d03c71$export$1d424793bb9cda35(key, vars = {}) {
    let text = $57ce9f9ca6d03c71$export$625550452a3fa3ec(key);
    Object.entries(vars).forEach(([k, v])=>{
        text = text.replace(`{${k}}`, v);
    });
    return text;
}

});
parcelRegister("6C6hx", function(module, exports) {

$parcel$export(module.exports, "translations", () => $013e1d9534acb01f$export$150b732325d14d04);
const $013e1d9534acb01f$export$150b732325d14d04 = {
    es: {
        app: {
            loader: "Cargando men\xfa...",
            error: {
                menu: "No se pudo cargar el men\xfa",
                theme: 'No se pudo cargar el tema',
                default: 'Ha ocurrido un error'
            }
        },
        fab: {
            menu: "Men\xfa",
            home: 'Inicio'
        },
        fallback: {
            product: 'Producto',
            option: "Opci\xf3n",
            section: "Secci\xf3n",
            page: "P\xe1gina"
        },
        lang: {
            missing: "Traducci\xf3n no disponible"
        },
        availability: {
            available: 'Disponible',
            unavailable: 'No disponible',
            endingSoon: "\xa1Termina pronto!",
            endingIn: 'Termina en {minutes} min'
        },
        modifiers: {
            required: 'Requerido',
            optional: 'Opcional',
            select: 'Seleccionar',
            minSelect: "M\xednimo {count}",
            maxSelect: "M\xe1ximo {count}"
        },
        actions: {
            share: 'Compartir',
            close: 'Cerrar',
            retry: 'Reintentar',
            scrollDown: 'Desliza hacia abajo'
        },
        offline: {
            title: "Sin conexi\xf3n",
            message: "No pudimos cargar el men\xfa. Por favor, verifica tu conexi\xf3n a internet e intenta de nuevo."
        }
    },
    en: {
        app: {
            loader: 'Loading menu...',
            error: {
                menu: 'Could not load menu',
                theme: 'Could not load theme',
                default: 'An error occurred'
            }
        },
        fab: {
            menu: 'Menu',
            home: 'Home'
        },
        fallback: {
            product: 'Product',
            option: 'Option',
            section: 'Section',
            page: 'Page'
        },
        lang: {
            missing: 'Translation not available'
        },
        availability: {
            available: 'Available',
            unavailable: 'Not available',
            endingSoon: 'Ending soon!',
            endingIn: 'Ends in {minutes} min'
        },
        modifiers: {
            required: 'Required',
            optional: 'Optional',
            select: 'Select',
            minSelect: 'Min {count}',
            maxSelect: 'Max {count}'
        },
        actions: {
            share: 'Share',
            close: 'Close',
            retry: 'Retry',
            scrollDown: 'Scroll down'
        },
        offline: {
            title: 'Offline',
            message: 'We could not load the menu. Please check your internet connection and try again.'
        }
    }
};

});

parcelRegister("8UcEY", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $67bd5fae4a7355ae$export$4be65e66cfa2648a);
$parcel$export(module.exports, "setCookie", () => $67bd5fae4a7355ae$export$110700823644f4a6);
/**
 * Cookie utilities
 * Simple helper functions for cookie management
 */ /**
 * Get cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */ function $67bd5fae4a7355ae$export$4be65e66cfa2648a(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}
function $67bd5fae4a7355ae$export$110700823644f4a6(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/';
}

});


parcelRegister("bdSeo", function(module, exports) {

$parcel$export(module.exports, "getCurrentCurrency", () => $82baf9ca48b67962$export$d58e82609be0f57b);
$parcel$export(module.exports, "getAvailableCurrencies", () => $82baf9ca48b67962$export$ec3d5cbd18920dd9);
$parcel$export(module.exports, "setCurrency", () => $82baf9ca48b67962$export$2562006be4e6c6b7);
$parcel$export(module.exports, "initCurrency", () => $82baf9ca48b67962$export$61fabdb233d3c167);
$parcel$export(module.exports, "formatPrices", () => $82baf9ca48b67962$export$ba5c9b9a11700a19);

var $8UcEY = parcelRequire("8UcEY");
/**
 * Currency formatting utilities
 * 
 * TODO: Replace Intl.NumberFormat with currency.js (src/currency.min.js)
 * Current implementation assumes prices are in whole units (e.g., 1435 = $1,435.00)
 * but actual data comes as cents (e.g., 1435 cents = $14.35)
 * currency.js handles precision correctly with fromCents option
 * 
 * Uses Proxy-based state management
 */ // Currency symbols
const $82baf9ca48b67962$var$CURRENCY_SYMBOLS = {
    'MXN': '$',
    'USD': '$',
    'EUR': "\u20AC",
    'GBP': "\xa3",
    'JPY': "\xa5",
    'CAD': 'C$',
    'AUD': 'A$',
    'BRL': 'R$',
    'ARS': '$',
    'CLP': '$',
    'COP': '$',
    'PEN': 'S/',
    'UYU': '$U'
};
const $82baf9ca48b67962$var$DEFAULT_CURRENCY = 'MXN';
// Local references (will be set during init)
let $82baf9ca48b67962$var$proxyState = null;
let $82baf9ca48b67962$var$availableCurrencies = [
    $82baf9ca48b67962$var$DEFAULT_CURRENCY
];
function $82baf9ca48b67962$export$d58e82609be0f57b() {
    if ($82baf9ca48b67962$var$proxyState) return $82baf9ca48b67962$var$proxyState.currency || $82baf9ca48b67962$var$DEFAULT_CURRENCY;
    return $82baf9ca48b67962$var$DEFAULT_CURRENCY;
}
function $82baf9ca48b67962$export$ec3d5cbd18920dd9() {
    return $82baf9ca48b67962$var$availableCurrencies;
}
function $82baf9ca48b67962$export$2562006be4e6c6b7(currency) {
    if (!$82baf9ca48b67962$var$availableCurrencies.includes(currency)) {
        console.warn(`[Currency] ${currency} not available`);
        return;
    }
    if ($82baf9ca48b67962$var$proxyState) $82baf9ca48b67962$var$proxyState.currency = currency;
}
function $82baf9ca48b67962$export$c86caf1be068fb8d(amount, currency = null) {
    const curr = currency || $82baf9ca48b67962$export$d58e82609be0f57b();
    const symbol = $82baf9ca48b67962$var$CURRENCY_SYMBOLS[curr] || curr;
    // Format number with locale - amount is already in whole units, not cents
    const formatted = new Intl.NumberFormat('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
    return `${symbol}${formatted}`;
}
function $82baf9ca48b67962$export$45083f6d2fa820eb(amount, currency = null) {
    const curr = currency || $82baf9ca48b67962$export$d58e82609be0f57b();
    const symbol = $82baf9ca48b67962$var$CURRENCY_SYMBOLS[curr] || curr;
    return `${symbol}${amount}`;
}
function $82baf9ca48b67962$export$61fabdb233d3c167(branchConfig, stateProxy) {
    $82baf9ca48b67962$var$proxyState = stateProxy;
    // Set available currencies from backend
    if (branchConfig?.availableCurrencies) $82baf9ca48b67962$var$availableCurrencies = branchConfig.availableCurrencies;
    // Priority 1: Check URL param (highest priority for sharing links)
    const urlCurrency = new URLSearchParams(window.location.search).get('currency');
    if (urlCurrency && $82baf9ca48b67962$var$availableCurrencies.includes(urlCurrency)) {
        $82baf9ca48b67962$var$proxyState.currency = urlCurrency;
        return;
    }
    // Priority 2: Check cookie
    const cookieCurrency = (0, $8UcEY.getCookie)('currency');
    if (cookieCurrency && $82baf9ca48b67962$var$availableCurrencies.includes(cookieCurrency)) {
        $82baf9ca48b67962$var$proxyState.currency = cookieCurrency;
        return;
    }
    // Priority 3: Backend default
    if (branchConfig?.defaultCurrency && $82baf9ca48b67962$var$availableCurrencies.includes(branchConfig.defaultCurrency)) {
        $82baf9ca48b67962$var$proxyState.currency = branchConfig.defaultCurrency;
        return;
    }
    // Priority 4: Hardcoded default
    $82baf9ca48b67962$var$proxyState.currency = $82baf9ca48b67962$var$DEFAULT_CURRENCY;
}
function $82baf9ca48b67962$export$ba5c9b9a11700a19(prices) {
    if (!prices || prices.length === 0) return '';
    const currentCurrency = $82baf9ca48b67962$export$d58e82609be0f57b();
    // Find price in current currency
    const price = prices.find((p)=>p.currency === currentCurrency) || prices[0];
    return $82baf9ca48b67962$export$c86caf1be068fb8d(price.amount, price.currency);
}
function $82baf9ca48b67962$export$4f7b2ae0c2141b10(currency = null) {
    return $82baf9ca48b67962$var$CURRENCY_SYMBOLS[currency || $82baf9ca48b67962$export$d58e82609be0f57b()] || currency || $82baf9ca48b67962$export$d58e82609be0f57b();
}

});

parcelRegister("1GtAL", function(module, exports) {
module.exports = import("dNMFk").then(()=>parcelRequire('1MEF0'));

});

parcelRegister("gnRS1", function(module, exports) {
module.exports = import("2UNS6").then(()=>parcelRequire('hx3Hw'));

});

parcelRegister("ehOBu", function(module, exports) {
module.exports = import("2H0qN").then(()=>parcelRequire('8hR0C'));

});

parcelRegister("aWioh", function(module, exports) {
module.exports = Promise.all([
    import("27FuN"),
    import("atxAo"),
    import("kYvQF")
]).then(()=>parcelRequire('cDmD8'));

});

parcelRegister("03SuV", function(module, exports) {
module.exports = import("atxAo").then(()=>parcelRequire('1QDDI'));

});

parcelRegister("1PKYQ", function(module, exports) {
module.exports = Promise.all([
    import("atxAo"),
    import("27FuN")
]).then(()=>parcelRequire('6orWw'));

});

parcelRegister("g0Hqx", function(module, exports) {
module.exports = import("dsbWu").then(()=>parcelRequire('9W6e6'));

});

parcelRegister("dXnvr", function(module, exports) {
module.exports = import("aYHWz").then(()=>parcelRequire('6kpKo'));

});

parcelRegister("dklxi", function(module, exports) {
module.exports = import("a8Zvt").then(()=>parcelRequire('fCHmY'));

});

parcelRegister("fP3Tb", function(module, exports) {
module.exports = import("edVfx").then(()=>parcelRequire('kfgCp'));

});

parcelRegister("fdKwf", function(module, exports) {
module.exports = import("9xEUR").then(()=>parcelRequire('8zYkj'));

});

/**
 * Main entry point for QR Smart Menu SPA
 * Implements Proxy-based state management with reactive effects
 */ /**
 * API utilities for fetching menu data
 * Implements Proxy-based state management with validation
 */ // API base URL
const $eaaba8a5ae480d72$var$API_BASE = '/api/v1/public/menu';
// Allowed state keys for proxy validation
const $eaaba8a5ae480d72$var$ALLOWED_KEYS = new Set([
    'lang',
    'currency',
    'theme',
    'fontSize'
]);
async function $eaaba8a5ae480d72$export$cd52ca8a24a95739() {
    const response = await fetch($eaaba8a5ae480d72$var$API_BASE, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
        }
    });
    if (!response.ok) {
        if (response.status === 404) throw new Error('Menu not found');
        throw new Error(`Failed to load menu: ${response.status}`);
    }
    const data = await response.json();
    if (!data.success) throw new Error(data.message || 'Failed to load menu');
    return data.data;
}
function $eaaba8a5ae480d72$export$e1a92bbdff65c4c0() {
    const dataPromise = $eaaba8a5ae480d72$export$cd52ca8a24a95739().then((hugePayload)=>{
        // Freeze the API data to prevent mutations
        const frozenContent = Object.freeze(hugePayload);
        const internalState = {};
        const pendingChanges = new Map();
        let flushScheduled = false;
        // Get the event bus
        const bus = globalThis[Symbol.for('APP_BUS')];
        const flush = ()=>{
            // Dispatch individual change events
            for (const [key, value] of pendingChanges)bus.dispatchEvent(new CustomEvent(`change:${key}`, {
                detail: value
            }));
            // Dispatch batch event with all changes
            bus.dispatchEvent(new CustomEvent('change:batch', {
                detail: Object.fromEntries(pendingChanges)
            }));
            pendingChanges.clear();
            flushScheduled = false;
        };
        const stateProxy = new Proxy(internalState, {
            set (target, prop, value) {
                const key = String(prop);
                // Validate key is allowed
                if (!$eaaba8a5ae480d72$var$ALLOWED_KEYS.has(key)) {
                    console.warn(`[State] Invalid key: ${key}. Allowed: ${Array.from($eaaba8a5ae480d72$var$ALLOWED_KEYS).join(', ')}`);
                    return false;
                }
                // Skip if value hasn't changed
                if (target[key] === value) return true;
                target[key] = value;
                pendingChanges.set(key, value);
                // Schedule flush only once per sync tick
                if (!flushScheduled) {
                    flushScheduled = true;
                    queueMicrotask(flush);
                }
                return true;
            },
            get (target, prop) {
                return target[prop];
            }
        });
        return {
            content: frozenContent,
            state: stateProxy
        };
    });
    globalThis[Symbol.for('APP_DATA')] = dataPromise;
    return dataPromise;
}
async function $eaaba8a5ae480d72$export$cffaac380b94df26(url, options = {}, maxRetries = 3) {
    let lastError;
    for(let i = 0; i < maxRetries; i++)try {
        const response = await fetch(url, options);
        if (response.ok) return response;
        throw new Error(`HTTP ${response.status}`);
    } catch (error) {
        lastError = error;
        const delay = Math.pow(2, i) * 1000;
        await new Promise((resolve)=>setTimeout(resolve, delay));
    }
    throw lastError;
}


/**
 * PWA Service Worker registration utilities
 */ const $a78f527e3f4e2c86$var$SW_PATH = '/sw.js';
async function $a78f527e3f4e2c86$export$c6245babf0c60892() {
    if (!('serviceWorker' in navigator)) {
        console.log('[PWA] Service Worker not supported');
        return false;
    }
    // Skip in development (localhost or any subdomain of localhost)
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.endsWith('.localhost') || window.location.protocol === 'http:' && window.location.port !== ''; // Parcel dev server
    if (isLocalhost) {
        console.log('[PWA] Skipping SW registration in development');
        return false;
    }
    try {
        const registration = await navigator.serviceWorker.register($a78f527e3f4e2c86$var$SW_PATH, {
            scope: '/'
        });
        console.log('[PWA] Service Worker registered:', registration.scope);
        // Handle updates
        registration.addEventListener('updatefound', ()=>{
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', ()=>{
                if (newWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // New update available
                        console.log('[PWA] New version available');
                        $a78f527e3f4e2c86$var$showUpdateNotification(newWorker);
                    } else // First install
                    console.log('[PWA] Content cached for offline use');
                }
            });
        });
        return registration;
    } catch (error) {
        console.error('[PWA] SW registration failed:', error);
        return false;
    }
}
/**
 * Show update notification
 */ function $a78f527e3f4e2c86$var$showUpdateNotification(worker) {
    // Dispatch event that app can listen to
    globalThis[Symbol.for('APP_BUS')].dispatchEvent(new CustomEvent('pwa:update', {
        detail: {
            worker: worker
        }
    }));
}
async function $a78f527e3f4e2c86$export$9ea0b2012e5b2900() {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration && registration.waiting) registration.waiting.postMessage({
        type: 'SKIP_WAITING'
    });
}
function $a78f527e3f4e2c86$export$72fee83dd1572775() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}
function $a78f527e3f4e2c86$export$35872d86d4dae14b() {
    $a78f527e3f4e2c86$export$c6245babf0c60892();
    console.log('[PWA] Initialized, standalone:', $a78f527e3f4e2c86$export$72fee83dd1572775());
}



var $7xovm = parcelRequire("7xovm");

var $bdSeo = parcelRequire("bdSeo");

var $8UcEY = parcelRequire("8UcEY");
/**
 * Global Schedule Ticker Singleton
 * Dispatches schedule-tick event every 60 seconds via APP_BUS
 */ class $e8d8fd10db032336$var$ScheduleTicker {
    constructor(){
        this.intervalId = null;
        this.timeoutId = null;
        this.isRunning = false;
    }
    start() {
        if (this.isRunning) return;
        this.isRunning = true;
        // Dispatch initial tick immediately
        this.#dispatchTick();
        // Calculate ms until the exact next minute (HH:MM:00.000)
        const now = new Date();
        const msUntilNextMinute = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());
        // Schedule the first precise tick and the subsequent interval
        this.timeoutId = setTimeout(()=>{
            if (!this.isRunning) return; // In case it was stopped during the wait
            this.#dispatchTick();
            this.intervalId = setInterval(()=>{
                this.#dispatchTick();
            }, 60000);
        }, msUntilNextMinute);
        console.log(`[ScheduleTicker] Started. Syncing next tick in ${msUntilNextMinute}ms`);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (this.isRunning) {
            this.isRunning = false;
            console.log('[ScheduleTicker] Stopped');
        }
    }
    #dispatchTick() {
        const bus = globalThis[Symbol.for('APP_BUS')];
        if (bus) bus.dispatchEvent(new CustomEvent('schedule-tick', {
            detail: {
                now: new Date()
            }
        }));
    }
}
const $e8d8fd10db032336$export$e94d57566be028aa = new $e8d8fd10db032336$var$ScheduleTicker();


// Initialize global event bus FIRST
if (!globalThis[Symbol.for('APP_BUS')]) globalThis[Symbol.for('APP_BUS')] = new EventTarget();
// State effects - automatically triggered on state changes
const $2b6e161c9edcf319$var$stateEffects = {
    lang: (val)=>{
        (0, $8UcEY.setCookie)('lang', val, 30);
        document.documentElement.lang = val;
    },
    currency: (val)=>{
        (0, $8UcEY.setCookie)('currency', val, 30);
        console.log(`[Effect] Currency changed to ${val}`);
    },
    theme: (val)=>{
        localStorage.setItem('app-theme', val);
        // Apply theme class to document
        document.documentElement.setAttribute('data-theme', val);
    },
    fontSize: (val)=>{
        document.documentElement.style.setProperty('--main-size', `${val}px`);
    }
};
// Start app
$2b6e161c9edcf319$var$init();











async function $2b6e161c9edcf319$var$init() {
    console.log('[App] Initializing QR Smart Menu...');
    try {
        // 1. Start fetching data - this creates the Proxy state
        const { content: data, state: state } = await (0, $eaaba8a5ae480d72$export$e1a92bbdff65c4c0)();
        console.log('[App] Data loaded, state proxy created');
        // 2. Setup state effects listeners
        $2b6e161c9edcf319$var$setupStateEffects();
        // 3. Initialize i18n and currency (they will use the proxy)
        if (data.branch?.config) {
            (0, $7xovm.initI18n)(data.branch.config, state);
            (0, $bdSeo.initCurrency)(data.branch.config, state);
        }
        // 4. Import and register components
        await (parcelRequire("1GtAL"));
        await (parcelRequire("gnRS1"));
        await (parcelRequire("ehOBu"));
        await (parcelRequire("aWioh"));
        await (parcelRequire("03SuV"));
        await (parcelRequire("1PKYQ"));
        await (parcelRequire("g0Hqx"));
        await (parcelRequire("dXnvr"));
        await (parcelRequire("dklxi"));
        await (parcelRequire("fP3Tb"));
        await (parcelRequire("fdKwf"));
        // 5. Render the app
        $2b6e161c9edcf319$var$renderApp();
        // 6. Start other services
        (0, $e8d8fd10db032336$export$e94d57566be028aa).start();
        (0, $a78f527e3f4e2c86$export$35872d86d4dae14b)();
        console.log('[App] Initialized successfully');
        // Dispatch ready event
        globalThis[Symbol.for('APP_BUS')].dispatchEvent(new CustomEvent('app:ready', {
            detail: data
        }));
    } catch (error) {
        console.error('[App] Initialization failed:', error);
        $2b6e161c9edcf319$var$showError(error.message);
    }
}
function $2b6e161c9edcf319$var$setupStateEffects() {
    const bus = globalThis[Symbol.for('APP_BUS')];
    // Listen for batch changes and apply effects
    bus.addEventListener('change:batch', (e)=>{
        const changes = e.detail;
        console.log('[Effects] Batch changes:', changes);
        for (const [key, value] of Object.entries(changes))if ($2b6e161c9edcf319$var$stateEffects[key]) $2b6e161c9edcf319$var$stateEffects[key](value);
    });
    // Also listen for individual changes (for components that need immediate response)
    Object.keys($2b6e161c9edcf319$var$stateEffects).forEach((key)=>{
        bus.addEventListener(`change:${key}`, (e)=>{
            $2b6e161c9edcf319$var$stateEffects[key](e.detail);
        });
    });
}
function $2b6e161c9edcf319$var$renderApp() {
    const app = document.getElementById('app');
    if (app) app.innerHTML = `
      <menu-frame>
        <menu-app></menu-app>
        <menu-context-sheet></menu-context-sheet>
        <menu-config></menu-config>
        <menu-nav-sheet></menu-nav-sheet>
        <menu-nav></menu-nav>
        <menu-toast></menu-toast>
      </menu-frame>
    `;
}
function $2b6e161c9edcf319$var$showError(message) {
    const app = document.getElementById('app');
    if (app) app.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 20px;
        text-align: center;
      ">
        <div style="font-size: 48px; margin-bottom: 16px;">\u{26A0}\u{FE0F}</div>
        <h1 style="font-size: 20px; margin-bottom: 8px; color: #222;">
          No se pudo cargar el men\xfa
        </h1>
        <p style="color: #666; margin-bottom: 20px;">
          ${message || 'Ha ocurrido un error'}
        </p>
        <button onclick="window.location.reload()" style="
          background: #007AFF;
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
        ">
          Reintentar
        </button>
      </div>
    `;
}


//# sourceMappingURL=client.8c5f5068.js.map
